import React, { ReactNode, useContext, useEffect, useState } from 'react';

import OsPatchContext from '@totem/components/devices/os-patches/osPatchContext';
import { OSPatch } from '@totem/components/devices/os-patches/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { DEVICES_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  id: string;
  children?: ReactNode;
};

const OSPatchContainer = ({ id, children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [refreshData, setRefreshData] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [data, setData] = useState<OSPatch[]>([]);
  const [action, setAction] = useState<string>('');
  const [actionItem, setActionItem] = useState<OSPatch>(null);

  useEffect(() => {
    if (refreshData) {
      setRefreshData(false);

      setIsLoading(true);

      const uri = `${DEVICES_ENDPOINT}/${id}/os-patches`;

      fetch(uri, {
        method: 'GET',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
      })
        .then((res) => res.json())
        .then((result: OSPatch[]) => {
          setData(result);
        })
        .then(() => {
          setIsLoading(false);
        });
    }
  }, [id, refreshData, getApiToken]);

  const handleAction = (newAction: string, item: OSPatch) => {
    switch (newAction) {
      default:
        setAction(newAction);

        setActionItem(item);
    }
  };

  return (
    <OsPatchContext.Provider
      value={{
        deviceId: id,
        loading: isLoading,
        data,
        action,
        actionItem,
        onAction: handleAction,
      }}
    >
      <div>{children}</div>
    </OsPatchContext.Provider>
  );
};

export default OSPatchContainer;
